import React, { useState } from "react";
import { Form } from "../../../layout";
import {
  Divider,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import { Button, Input, InputAuto, InputDate } from "../../../controls";
import { Model, UseForm } from "../../../hooks";
import { useNavigate, useParams } from "react-router-dom";
import { ArrowBackRounded, DeleteForeverRounded } from "@mui/icons-material";
import { dog_cloth } from "../../../assets";

const StockTransForm = (props) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading] = useState(false);
  const [searchVal, setSearchVal] = useState("");
  const { StockTransMdl } = Model();
  const { values, errors, setErrors, handleInpChg, handleInpDate } =
    UseForm(StockTransMdl);

  const validateForm = () => {
    let temp = {};
    temp.fromOutlet =
      values.fromOutlet !== "" ? "" : "From outlet is required.";
    temp.toOutlet = values.toOutlet !== "" ? "" : "To outlet is required.";

    setErrors({ ...temp });
    return Object.values(temp).every((x) => x === "");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
    }
  };

  const handleProdSearch = (e) => {
    setSearchVal(e.target.value);
  };

  return (
    <Form onSubmit={handleSubmit} noValidate>
      <Paper>
        <div className="flex justify-between items-center p-[10px]">
          <div className="flex items-center gap-[10px]">
            <div>
              <IconButton size="small" onClick={() => navigate(-1)}>
                <ArrowBackRounded />
              </IconButton>
            </div>

            <div>
              <h1 className="form-title font-normal text-gray-500 uppercase">
                Stock Transfer
              </h1>
            </div>
          </div>

          <div>
            <Button type="submit" loading={loading}>
              {id ? "Save Changes" : "Submit"}
            </Button>
          </div>
        </div>
        <Divider />
        <div className="p-[15px] mt-[15px]">
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <InputAuto
                label="From Outlet"
                name="fromOutlet"
                required={true}
                value={values.fromOutlet}
                error={errors.fromOutlet}
                onChange={handleInpChg}
                options={[
                  { id: 1, label: "Outlet - 1" },
                  { id: 2, label: "Outlet - 2" },
                  { id: 3, label: "Outlet - 3" },
                  { id: 4, label: "Outlet - 4" },
                  { id: 5, label: "Outlet - 5" },
                ]}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <InputAuto
                label="To Outlet"
                name="toOutlet"
                required={true}
                value={values.toOutlet}
                error={errors.toOutlet}
                onChange={handleInpChg}
                options={[
                  { id: 1, label: "Outlet - 1" },
                  { id: 2, label: "Outlet - 2" },
                  { id: 3, label: "Outlet - 3" },
                  { id: 4, label: "Outlet - 4" },
                  { id: 5, label: "Outlet - 5" },
                ]}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Input
                label="Reference"
                name="refe"
                value={values.refe}
                onChange={handleInpChg}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <InputDate
                label="Date"
                name="date"
                value={values.date}
                onChange={(date) =>
                  handleInpDate("date", new Date(date).toLocaleDateString())
                }
              />
            </Grid>
            <Grid item xs={12}>
              <div className="flex items-center pl-[5px] mt-[20px]">
                <span
                  className="text-gray-color uppercase font-medium"
                  style={{ minWidth: "100px" }}
                >
                  Products
                </span>
                <div className="bs-secondary w-[100%]" />
              </div>
            </Grid>
            <Grid item xs={12}>
              <InputAuto
                label="Search or scan to add a product"
                value={searchVal}
                onChange={handleProdSearch}
                options={[
                  { id: 1, label: "Product 1" },
                  { id: 2, label: "Product 2" },
                  { id: 3, label: "Product 3" },
                  { id: 4, label: "Product 4" },
                  { id: 5, label: "Product 5" },
                ]}
              />
            </Grid>
            <Grid item xs={12}>
              <TableContainer className="bs-secondary !rounded-[15px] bg-inherit">
                <Table size="medium">
                  <TableHead>
                    <TableRow>
                      <TableCell>Product</TableCell>
                      <TableCell>Inventory at from outlet</TableCell>
                      <TableCell>Inventory at to outlet</TableCell>
                      <TableCell>Quantity</TableCell>
                      <TableCell>Cost Price</TableCell>
                      <TableCell>Total Cost</TableCell>
                      <TableCell align="right"></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {prods.map((prod, i) => (
                      <TableRow
                        hover
                        key={i}
                        sx={{ "& > *": { borderBottom: "unset" } }}
                      >
                        <TableCell>
                          <div className="flex items-center gap-[10px]">
                            <img
                              src={prod.img}
                              alt="product_img"
                              className="img-fluid w-[40px] bg-white rounded-[10px] shadow-xs"
                            />
                            <div className="mr-[20px] grid ml-[10px]">
                              <span className="text-[16px]">{prod.name}</span>
                              <span className="text-[12px] text-gray-500">
                                {prod.skuCode}
                              </span>
                            </div>
                          </div>
                        </TableCell>
                        <TableCell>
                          <span className="text-[16px]">
                            {prod.fromOutletInv}
                          </span>
                        </TableCell>
                        <TableCell>
                          <span className="text-[16px]">
                            {prod.toOutletInv}
                          </span>
                        </TableCell>
                        <TableCell>
                          <Input
                            className="shadow-xs"
                            variant="outlined"
                            size="small"
                            placeholder="$ 0.00"
                            sx={{ maxWidth: "200px" }}
                            value={prod.qty}
                            inputProps={{ maxLength: 200 }}
                          />
                        </TableCell>

                        <TableCell>
                          <Input
                            className="shadow-xs"
                            variant="outlined"
                            placeholder="$ 0.00"
                            size="small"
                            sx={{ maxWidth: "200px" }}
                            value={prod.qty}
                            inputProps={{ maxLength: 200 }}
                          />
                        </TableCell>
                        <TableCell>
                          <span
                            className="text-[18px] text-gray-500"
                            style={{ minWidth: "200px" }}
                          >
                            $&nbsp;{prod.totalPrice}
                          </span>
                        </TableCell>
                        <TableCell align="right">
                          <Tooltip title="Delete this variants">
                            <IconButton color="error" size="small">
                              <DeleteForeverRounded className="text-[28px]" />
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    ))}
                    <TableRow>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell className="text-[16px] font-bold text-gray-500 uppercase">
                        Total Cost:
                      </TableCell>
                      <TableCell className="text-[16px] font-bold text-gray-500 uppercase">
                        $0.00
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        </div>
      </Paper>
    </Form>
  );
};

export default StockTransForm;

const prods = [
  {
    id: 1,
    img: dog_cloth,
    name: "Product Name - 1",
    skuCode: "1245345",
    toOutletInv: "8",
    fromOutletInv: "5",
    qty: "",
    price: "",
    totalPrice: "0.00",
  },
  {
    id: 1,
    img: dog_cloth,
    name: "Product Name - 1",
    skuCode: "1245345",
    toOutletInv: "8",
    fromOutletInv: "5",
    qty: "",
    price: "",
    totalPrice: "0.00",
  },
  {
    id: 1,
    img: dog_cloth,
    name: "Product Name - 1",
    skuCode: "1245345",
    toOutletInv: "8",
    fromOutletInv: "5",
    qty: "",
    price: "",
    totalPrice: "0.00",
  },
  {
    id: 1,
    img: dog_cloth,
    name: "Product Name - 1",
    skuCode: "1245345",
    toOutletInv: "8",
    fromOutletInv: "5",
    qty: "",
    price: "",
    totalPrice: "0.00",
  },
  {
    id: 1,
    img: dog_cloth,
    name: "Product Name - 1",
    skuCode: "1245345",
    toOutletInv: "8",
    fromOutletInv: "5",
    qty: "",
    price: "",
    totalPrice: "0.00",
  },
];
